import React from "react";
import View from "../commons/View";
import AppText from "../commons/AppText";
import {FontSizeNormal, FontSizeSmall} from "src/res/FontSize";
import {FontWeightBold, FontWeightMedium} from "src/res/FontWeight";
import ImageBackground from "../commons/ImageBackground";
import AppTextWrapper from "../commons/AppTextWrapper";
import {locHtmlString, locString} from "../commons/ViewHelper";
import TouchableOpacity from "../commons/TouchableOpacity";
import AppImage from "../commons/AppImage";
import {RadiusView} from "src/res/Radius";
import TextField from "@material-ui/core/TextField";
import constants from "../../constants";
import {textFieldIntegerOnKeyDown} from "../../utils/ValueHelper";
import AppImageButtonEx from "../commons/AppImageButtonEx";
import Paper from "@material-ui/core/Paper";
import {colorWithAlpha, getMostReadableColor} from "src/js/utils/AppUtils";
import TextView from "src/js/components/commons/TextView";
import {Button} from "@material-ui/core";
import AppIcon, {IconCircle, IconTrophy} from "src/js/components/commons/AppIcon";
import Space from "src/js/components/commons/Space";

export const GetPredictionActionView = (props) => {
   const {uiConfigs, isLTR, contentWidth, title, value1Placeholder, value2Placeholder, imageUrl1, imageUrl2,
     guess1, guess2, canMakeAction, canEdit, disableAction, disableField,
     onChangeGuessTextField, onPredictClicked, onImageFSClicked} = props;
   const sizeFactor = uiConfigs.sizeFactor;
  const sizeVFactor = uiConfigs.sizeVFactor;
  const gameImagesWidthPercent = 0.8;
  const imageCountFactor = imageUrl2 ? 2 : 2 - (0.9 * sizeVFactor);
  const imageSize = ((contentWidth - 16) * gameImagesWidthPercent - 80 * sizeFactor) / imageCountFactor;

  let value1PlaceholderL = null;
  if (value1Placeholder && value1Placeholder.length > 0) {
    value1PlaceholderL = value1Placeholder;
  }
  let value2PlaceholderL = null;
  if (value2Placeholder && value2Placeholder.length > 0) {
    value2PlaceholderL = value2Placeholder;
  }

   return (
     <View style={{marginLeft: 8, marginRight: 8, marginBottom: 6, alignItems: 'center'}}>
       <View style={{width: '100%', maxWidth: contentWidth}}>
         {title ?
           <View style={{flexDirection: 'row', justifyContent: 'center'}}>
             <View style={{borderWidth: 1, borderColor: uiConfigs.messageBorderColor, borderRadius: 16, padding: 8}}>
               <AppText
                 fontSizeN={uiConfigs.fontSize}
                 style={{
                   color: uiConfigs.titleColor,
                   fontSize: FontSizeNormal,
                   fontWeight: FontWeightMedium,
                   textAlign: 'center'}}>
                 {title}
               </AppText>
             </View>
           </View>
           : null
         }
         <View>
           <ImageBackground source={value2PlaceholderL ? uiConfigs.gameTopImage : uiConfigs.gameTop1Image} resizeMode={'fill'} style={{position: 'absolute', left: 0, right: 0, top: 0, bottom: 0}} >
             <View style={{flex: 1, width: '100%', position: 'relative', flexDirection: 'row', minHeight: 24 * sizeFactor, marginTop: 22 * sizeFactor, marginBottom: 16 * sizeFactor, justifyContent: 'center'}}>
               <View style={{flex: value2PlaceholderL ? 0.26 : 0.42, justifyContent: 'center', alignItems: 'center'}}>
                 <AppTextWrapper fontSizeN={uiConfigs.fontSize} numberOfLines={3} style={{color: uiConfigs.titleColor, fontSize: FontSizeSmall, fontWeight: FontWeightMedium, textAlign: 'center'}}>
                   {value1PlaceholderL /* || locString('yourGuess') */}
                 </AppTextWrapper>
               </View>
               {value2PlaceholderL ?
                 <View style={{flex: 0.21}} />
                 : null
               }
               {value2PlaceholderL ?
                 <View style={{flex: 0.26, justifyContent: 'center', alignItems: 'center'}}>
                   <AppTextWrapper fontSizeN={uiConfigs.fontSize} numberOfLines={3} style={{color: uiConfigs.titleColor, fontSize: FontSizeSmall, fontWeight: FontWeightMedium, textAlign: 'center'}}>
                     {value2PlaceholderL}
                   </AppTextWrapper>
                 </View>
                 : null
               }
             </View>
           </ImageBackground>
           {imageUrl1 ?
             <View style={{width: '100%', marginTop: -4 * sizeFactor, flexDirection: 'row', justifyContent: 'center'}}>
               <ImageBackground source={uiConfigs.gameBgImage} resizeMode={'fill'} style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center'}} >
                 <View style={{position: 'relative', width: '100%', flex: gameImagesWidthPercent, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: imageSize * 0.20, marginTop: imageSize * 0.06, marginLeft: 8 * sizeFactor, marginRight: 8 * sizeFactor}} >
                   <TouchableOpacity onClick={() => {
                     onImageFSClicked(imageUrl1);
                   }}>
                     <AppImage imageUrl={imageUrl1} resizeMode={'contain'} style={{width: imageSize, height: imageSize, borderRadius: RadiusView}}/>
                   </TouchableOpacity>
                   {imageUrl2 ?
                     <AppImage source={uiConfigs.gameVsImage} resizeMode={'fill'} style={{height: 16 * sizeFactor, width: 26 * sizeFactor, marginLeft: 16 * sizeFactor, marginRight: 16 * sizeFactor}} />
                     : null
                   }
                   {imageUrl2 ?
                     <TouchableOpacity onClick={() => {
                       onImageFSClicked(imageUrl2);
                     }}>
                       <AppImage imageUrl={imageUrl2} resizeMode={'contain'} style={{width: imageSize, height: imageSize, borderRadius: RadiusView}}/>
                     </TouchableOpacity>
                     : null
                   }
                 </View>
               </ImageBackground>
             </View>
             : null
           }
           <View style={{marginTop: imageUrl1 ? -8*sizeFactor : 16 * sizeVFactor, flexDirection: 'row', justifyContent: 'center'}}>
             <View style={{flex: 0.76, alignItems: 'center'}}>
               <View style={{width: '100%', height: 40 * sizeFactor, flexDirection: 'row', justifyContent: 'center', opacity: !disableField ? 1 : (guess1 ? 0.7 : 0.3)}}>
                 <View style={{flex: 1, justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
                   <ImageBackground source={value2PlaceholderL ? uiConfigs.gameTextLImage : uiConfigs.gameTextImage} resizeMode={'fill'} style={{position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}} >
                     <TextField
                       disabled={disableField}
                       keyboardType={'number-pad'}
                       onChange={onChangeGuessTextField}
                       // onSubmitEditing={() => {
                       //   if (this.refTextInputGuess2) {
                       //     this.refTextInputGuess2.focus();
                       //   }
                       // }}
                       size="small"
                       id="guess1"
                       name="guess1"
                       value={guess1 || ''}
                       style={{minWidth: 100 * sizeFactor, marginLeft: (isLTR ? 14 : 28) * sizeFactor, marginRight: (isLTR ? 28 : 14) * sizeFactor}}
                       InputProps={{disableUnderline: true}}
                       inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX, maxLength: 9, style: {textAlign: 'center', fontSize: uiConfigs.fontSize * 1.05, fontWeight: 'bold', color: uiConfigs.titleColor, paddingTop: 12 * sizeFactor, paddingBottom: 12 * sizeFactor}}}>
                     </TextField>
                   </ImageBackground>
                 </View>
                 {value2PlaceholderL ?
                   <View style={{flex: 1}} />
                   : null
                 }
                 {value2PlaceholderL ?
                   <View style={{flex: 1, justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
                     <ImageBackground source={uiConfigs.gameTextRImage} resizeMode={'fill'} style={{position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                       <TextField
                         // ref={(ref) => this.refTextInputGuess2 = ref}
                         disabled={disableField}
                         onChange={onChangeGuessTextField}
                         size="small"
                         id="guess2"
                         name="guess2"
                         value={guess2 || ''}
                         style={{minWidth: 100 * sizeFactor, marginLeft: (isLTR ? 28 : 12) * sizeFactor, marginRight: (isLTR ? 12 : 28) * sizeFactor}}
                         InputProps={{disableUnderline: true}}
                         inputProps={{min: 0, max: constants.activity.VALUE_DEFAULT_MAX, maxLength: 9, style: {textAlign: 'center', fontSize: uiConfigs.fontSize * 1.05, fontWeight: 'bold', color: uiConfigs.titleColor, paddingTop: 12 * sizeFactor, paddingBottom: 12 * sizeFactor}}}
                         onKeyDown={textFieldIntegerOnKeyDown}>
                       </TextField>
                     </ImageBackground>
                   </View>
                   : null
                 }
               </View>
               {canMakeAction ?
                 <AppImageButtonEx
                   disabled={disableAction}
                   imageStyle={{width: 200 * sizeFactor, height: 40 * sizeFactor, marginTop: 2 * sizeVFactor}}
                   titleStyle={{color: uiConfigs.actionTitleColor}}
                   onClick={onPredictClicked}
                   title={locString(canEdit ? 'edit' : 'submit')}
                   imageSource={uiConfigs.otherActionImage} />
                 : null
               }
             </View>
           </View>
         </View>
       </View>
     </View>
   );
};

export const GetPredictWinnerActionView = (props) => {
  const {classes, uiConfigs, intl, isLTR, contentWidth, title, value1Placeholder, value2Placeholder, imageUrl1, imageUrl2,
    guess1, guess2, canMakeAction, onChangePredictionSelector, onImageFSClicked} = props;
  const sizeFactor = uiConfigs.sizeFactor;
  const sizeVFactor = uiConfigs.sizeVFactor;
  const vsWidth = 60 * sizeFactor;
  const textSize = Math.min(200*sizeFactor, (contentWidth - 32 - vsWidth) / 2);
  let imageSize = Math.min(140*sizeFactor, (contentWidth - 32 - vsWidth) / 2);
  if (imageSize === textSize) {
    imageSize -= 16;
  }

  let value1PlaceholderL = null;
  if (value1Placeholder && value1Placeholder.length > 0) {
    value1PlaceholderL = value1Placeholder;
  }
  if (!value1PlaceholderL) {
    value1PlaceholderL = locString('activity.opponent1PW', null, intl);
  }
  let value2PlaceholderL = null;
  if (value2Placeholder && value2Placeholder.length > 0) {
    value2PlaceholderL = value2Placeholder;
  }
  if (!value2PlaceholderL) {
    value2PlaceholderL = locString('activity.opponent2PW', null, intl);
  }

  const getButton = (value, title, icon, isSelected, bgColor, fullWidth, borderRadiusLeft, borderRadiusRight) => {
    const titleColor = getMostReadableColor(bgColor);
    return (
      <Button
        elevation={2}
        onClick={()=>onChangePredictionSelector(value)}
        fullWidth={fullWidth}
        disabled={!canMakeAction}
        style={{minWidth: 80*sizeFactor, backgroundColor: bgColor, borderTopLeftRadius: borderRadiusLeft, borderBottomLeftRadius: borderRadiusLeft, borderTopRightRadius: borderRadiusRight, borderBottomRightRadius: borderRadiusRight, color: titleColor, opacity: !canMakeAction ? 0.8 : 1}}>
        <div className={classes.flexColumn}>
          <React.Fragment>
            <div className={classes.viewColumn} style={{width: 24*sizeFactor, height: 24*sizeFactor, borderRadius: 12*sizeFactor, backgroundColor: titleColor, padding: 2*sizeFactor, pointerEvents: 'none', opacity: isSelected || canMakeAction ? 1 : 0}}>
              <div className={classes.flexColumn} style={{backgroundColor: bgColor, borderRadius: 10*sizeFactor, justifyContent: 'center'}}>
                {isSelected ? <AppIcon icon={icon} color={titleColor} style={{width: 13*sizeFactor, height: 13*sizeFactor}}/> : null}
              </div>
            </div>
          </React.Fragment>
          <Space horizontal={4}/>
          <TextView variant={'body2'} fontSizeN={uiConfigs.fontSize} numberOfLines={2} style={{color: titleColor, fontWeight: FontWeightMedium, textAlign: 'center'}}>
            {title}
          </TextView>
        </div>
      </Button>
    )
  }

  const colorTitleDim = colorWithAlpha(uiConfigs.titleColor, 0.05);
  const colorTitleGlow = colorWithAlpha(uiConfigs.titleColor, 0.4);

  return (
    <View style={{width: '100%', maxWidth: contentWidth, paddingLeft: 16, paddingRight: 16, paddingTop: 6, paddingBottom: 6, alignItems: 'center'}}>
      <View style={{flexDirection: 'row', justifyContent: 'center'}}>
        <AppText
          fontSizeN={uiConfigs.fontSize}
          style={{
            color: uiConfigs.titleColor,
            fontSize: FontSizeNormal,
            fontWeight: FontWeightMedium,
            textAlign: 'center',
            marginBottom: 24}}>
          {title}
        </AppText>
      </View>
      <View className={classes.viewRowFullWidth} style={{justifyContent: 'center'}}>
        <div className={classes.viewRow} style={{width: textSize, justifyContent: 'center'}}>
          <Paper elevation={0} className={classes.viewColumn} style={{borderRadius: 4, padding: 1, borderColor: colorWithAlpha(uiConfigs.titleColor, 0.2), borderStyle: 'solid', borderWidth: 0, background: 'radial-gradient(circle, '+ colorWithAlpha(uiConfigs.titleColor, 0.5) +','+ colorWithAlpha(uiConfigs.titleColor, 0.1)}}>
            <TouchableOpacity onClick={() => {onImageFSClicked(imageUrl1)}}>
              {imageUrl1 ? <AppImage imageUrl={imageUrl1} resizeMode={'contain'} style={{width: imageSize, height: imageSize, borderRadius: 4}}/>
                : <div style={{width: imageSize, height: imageSize}}/>}
            </TouchableOpacity>
          </Paper>
        </div>
        <View style={{minWidth: vsWidth}} />
        <div className={classes.viewRow} style={{width: textSize, justifyContent: 'center'}}>
          <Paper elevation={0} className={classes.viewColumn} style={{borderRadius: 4, padding: 1, borderColor: colorWithAlpha(uiConfigs.titleColor, 0.2), borderStyle: 'solid', borderWidth: 0, background: 'radial-gradient(circle, '+ colorWithAlpha(uiConfigs.titleColor, 0.5) +','+ colorWithAlpha(uiConfigs.titleColor, 0.1)}}>
            <TouchableOpacity onClick={() => {onImageFSClicked(imageUrl2)}}>
              {imageUrl2 ? <AppImage imageUrl={imageUrl2} resizeMode={'contain'} style={{width: imageSize, height: imageSize, borderRadius: 4}}/>
                : <div style={{width: imageSize, height: imageSize}}/>}
            </TouchableOpacity>
          </Paper>
        </div>
      </View>

      <View className={classes.viewRowFullWidth} style={{justifyContent: 'center', marginTop: -8*sizeFactor}}>
        <Paper elevation={0} className={classes.flexColumn} style={{maxWidth: textSize + vsWidth/2, justifyContent: 'center', borderRadius: 4, minHeight: 40*sizeFactor, padding: 0, paddingLeft: 2, paddingRight: 2 + vsWidth/2, marginRight: -vsWidth/2, borderColor: colorWithAlpha(uiConfigs.titleColor, 0.2), borderStyle: 'solid', borderWidth: 0, borderTopWidth: 0, borderBottomWidth: 0, borderLeftWidth: 0, background: 'linear-gradient(90deg, ' + (isLTR ? colorTitleDim : colorTitleGlow) + ',' + (isLTR ? colorTitleGlow : colorTitleDim) + ')'}}>
          <AppText fontSizeN={uiConfigs.fontSize} numberOfLines={1} style={{color: uiConfigs.titleColor, fontWeight: FontWeightMedium, textAlign: 'center'}}>
            {value1PlaceholderL}
          </AppText>
        </Paper>
        <View style={{minWidth: vsWidth, minHeight: vsWidth, padding: 4, transform: 'rotate(45deg)'}}>
          <Paper className={classes.flexColumn} style={{justifyContent: 'center', borderRadius: RadiusView, padding: 2, borderColor: colorWithAlpha(uiConfigs.titleColor, 0.2), borderStyle: 'solid', borderWidth: 2, background: 'radial-gradient(circle, '+ colorWithAlpha(uiConfigs.themeColor, 0.8) +','+ colorWithAlpha(uiConfigs.themeColor, 1)}}>
            <TextView variant={'h6'} fontSizeN={uiConfigs.fontSize} numberOfLines={1} style={{color: uiConfigs.titleColor, fontWeight: FontWeightBold, textAlign: 'center', transform: 'rotate(-45deg)'}}>
              {'VS'}
            </TextView>
          </Paper>
        </View>
        <Paper elevation={0} className={classes.flexColumn} style={{maxWidth: textSize + vsWidth/2, justifyContent: 'center', borderRadius: 4, minHeight: 40*sizeFactor, padding: 0, paddingLeft: 2 + vsWidth/2, paddingRight: 2, marginLeft: -vsWidth/2, borderColor: colorWithAlpha(uiConfigs.titleColor, 0.2), borderStyle: 'solid', borderWidth: 0, borderTopWidth: 0, borderBottomWidth: 0, borderRightWidth: 0, background: 'linear-gradient(270deg, ' + (isLTR ? colorTitleDim : colorTitleGlow) + ',' + (isLTR ? colorTitleGlow : colorTitleDim) + ')'}}>
          <AppText fontSizeN={uiConfigs.fontSize} numberOfLines={1} style={{color: uiConfigs.titleColor, fontWeight: FontWeightMedium, textAlign: 'center'}}>
            {value2PlaceholderL}
          </AppText>
        </Paper>
      </View>

      <View className={classes.viewRowFullWidth} style={{maxWidth: Math.min(textSize*2 + vsWidth + 40, contentWidth - 32), marginTop: 24*sizeFactor, marginBottom: 16, justifyContent: 'center'}}>
        {getButton(2, locHtmlString('activity.opponentWin', {value: value1PlaceholderL}, intl), IconTrophy, guess1>guess2, uiConfigs.titleColor, true, isLTR ? 16 : 0, isLTR ? 0 : 16)}
        {getButton(1, locHtmlString('activity.drawNoResult', {}, intl), IconCircle, guess1 && guess2 && guess2===guess1, '#C5E1A5', false, 0, 0)}
        {getButton(3, locHtmlString('activity.opponentWin', {value: value2PlaceholderL}, intl), IconTrophy, guess2>guess1, uiConfigs.titleColor, true, isLTR ? 0 : 16, isLTR ? 16 : 0)}
      </View>
    </View>
  );
};
